module.exports = __webpack_public_path__ + "sneaker-pat.png";